import React from 'react';

const ChildSafetyStandards = () => {
  return (
    <div className="p-6 bg-white container mx-auto mt-4">
      <h1 className="text-2xl font-bold mb-4">Child Safety & Protection Policy – Roomease App</h1>
      
      <section className="mb-4">
        <h2 className="text-xl font-semibold">1. Compliance with Google Play’s Child Safety Policies</h2>
        <p>Roomease is committed to ensuring a safe and secure experience for all users, including minors. Our app adheres to Google Play's Families Policy and Designed for Families Program (if applicable), ensuring compliance with child safety standards.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold">2. Age Restrictions & User Eligibility</h2>
        <p>Roomease is intended for users aged 18 and above due to its purpose of facilitating roommate searches and communication.</p>
        <p>The app is not designed for children under 18, and we do not knowingly collect or process data from users below this age.</p>
        <p>Users under 18 are prohibited from signing up, and age verification measures may be implemented.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold">3. Data Privacy & Protection</h2>
        <p>Roomease follows COPPA (Children’s Online Privacy Protection Act) and GDPR-K (General Data Protection Regulation for Kids) guidelines to ensure the privacy of minors.</p>
        <p>No personal data from children is collected, stored, or shared.</p>
        <p>If we discover that a minor has provided personal data, we will take immediate action to remove such information.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold">4. Parental Controls & Restrictions</h2>
        <p>Parents and guardians are encouraged to monitor their children’s online activity.</p>
        <p>If a parent believes their child has interacted with the app without authorization, they can contact our support team for assistance.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold">5. Content & Advertising Standards</h2>
        <p>Roomease does not display age-inappropriate content, violence, or explicit materials.</p>
        <p>If in-app advertisements are used, they comply with Google’s Families Ads Program, ensuring no harmful or inappropriate ads are shown to minors.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold">6. Safety Features & User Reporting</h2>
        <p>Users can report inappropriate behavior or suspicious activity through our in-app reporting system.</p>
        <p>We actively moderate content and take action against users violating our safety policies.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold">7. Contact & Support</h2>
        <p>For any concerns related to child safety, privacy, or app misuse, please contact us at:</p>
        <p>Email: <a href="mailto:roomease.work@gmail.com" className="text-blue-500">roomease.work@gmail.com</a></p>
        <p>Phone: <a href="tel:9569994536" className="text-blue-500">9569994536</a></p>
      </section>
    </div>
  );
};

export default ChildSafetyStandards;
